import Service, { getCallApiFunction } from '../service'

export type ParamsType = {
  memberInfoId?: string
}
export type ResponseType = {
  isFollowed: boolean
}
class FetchIsMemberFollowedApi extends Service {
  constructor({ memberInfoId }: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/follow/isFollowed',
      method: 'GET',
      params: {
        id: memberInfoId,
      },
    }
  }
}
export const fetchIsMemberFollowed = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new FetchIsMemberFollowedApi(params))
